import { useEffect, useRef } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useNavigate } from "react-router-dom";
import ModelIndex, { ModelIndexHandle } from "@components/layout/ModelIndex";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { ZoneApi, ZoneDataType } from "@/api/ZoneApi";
import { showAlert } from "@utils/Alert";
import { useAdminContext } from "@/hooks/useAdminContext";

const ZonesIndex = () => {
  const navigate = useNavigate();
  const modelRef = useRef<ModelIndexHandle>(null);
  const { adminTenantId, isAdminMode, profileBackUrl, adminQuerySuffix } = useAdminContext();

  useEffect(() => {
  }, []);

  const deleteRecord = async (id: string) => {
    const { errors } = await ZoneApi.delete(id);
    if (errors?.length) {
      showAlert('danger', 'La Zona de clientes no puedo ser eliminado');
    } else {
      showAlert('success', 'La Zona de clientes fue eliminado correctamente');
    }
    modelRef.current?.refetch();
  }

  const fetchData = (...args: any[]) =>
    isAdminMode ? ZoneApi.fetchAllByOwnerId(adminTenantId!) : ZoneApi.fetchAll(...args);

  return (
    <PageContainer
      title="Zonas de clientes"
      backUrl={profileBackUrl}
      primaryActions={[
        {
          onClick: () => {
            navigate(`/user/client-zone${adminQuerySuffix}`)
          },
          actionTitle: "Nuevo",
          color: "success"
        }
      ]}
    >
      <ModelIndex<ZoneDataType>
        ref={modelRef}
        fetchData={fetchData}
        filterProps={[
          {
            key: "codigo",
            filterType: "eq",
            type: "number"
          },
          {
            key: "nombre",
            filterType: "contains"
          }
        ]}
        secondaryProperties={[
          {
            key: "codigo",
          },
          {
            key: "nombre"
          }
        ]}
        listActions={[
          {
            href: `/user/client-zone/{:id}${adminQuerySuffix}`,
            actionTitle: "Editar Zona de Clientes",
            iconProps: { icon: faEdit }
          },
          {
            actionTitle: "Eliminar Zona de Cliente",
            iconProps: { icon: faTrash },
            needConfirm: true,
            confirmProps: {
              title: "Eliminar  Zona de Cliente",
              confirmMessage: "¿Seguro que desea eliminar esta Zona de Cliente?",
              confirmBtnText: "Eliminar"
            },
            onClick: (id: string) => { deleteRecord(id) }
          }
        ]}
      >
      </ModelIndex>

    </PageContainer >
  );
}

export default ZonesIndex;
